import React, { useEffect, useState } from "react";

import {
  Breadcrumb,
  PageHeader,
  Table,
  Spin,
  Button,
} from "antd";

import { Link } from "react-router-dom";
import Page from "_components/Page";
import TabMenu from "./TabMenu";
import { materialTypeService } from "_services";

function Transactions({ match, history }) {
  const { id } = match.params;
  const { path } = match;

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    materialTypeService
      .getTransactions(id)
      .then((x) => {
        setItems(x.content);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
  }, []);

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Code",
      dataIndex: "stockType.code",
      key: "Code",
      render: (text, record) => {
        if (record) {
          return `${record?.stockType?.code}`;
        }
      },
    });
    columns.push({
      title: "Item Name",
      dataIndex: "stockType.name",
      key: "itemname",
      render: (text, record) => {
        if (record) {
          return `${record?.stockType?.name}`;
        }
      },
    });
    columns.push({
      title: "Username",
      dataIndex: "user.username",
      key: "Username",
      render: (text, record) => {
        if (record) {
          return `${record?.user?.username}`;
        }
      },
    });
    columns.push({
      title: "Company Name",
      dataIndex: "company.name",
      key: "Company Name",
      render: (text, record) => {
        if (record) {
          return `${record?.company?.name}`;
        }
      },
    });
    columns.push({
      title: "Type",
      dataIndex: "employee.username",
      key: "Type",
      render: (text, record) => {
        if (record) {
          return `${record?.transactionType?.transaction}`;
        }
      },
    });
    columns.push({
      title: "Quantity",
      dataIndex: "quantityValue",
      key: "Quantity",
      render: (text, record) => {
        if (record) {
          return `${record?.quantityValue ?? ""}`;
        }
      },
    });

    return columns;
  };

  const onCancel = () => {
    history.push("/material-types");
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/material-types">Material Type Search</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${path}`}>Transactions</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      extra={getActionButtons()}
    >
      <Page inner>
        <Spin tip="Loading..." spinning={loading}>
          <TabMenu menu="transactions" id={id} />

          {items && (
            <Table
              bordered
              pagination={false}
              columns={getLineColumns()}
              dataSource={items}
              size="small"
            />
          )}
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default Transactions;
